import axios from 'axios';

// export const QUANTA_API_BASE_URL = 'https://06e4f53f8a21.ngrok.app/';
// export const QUANTA_API_BASE_URL = 'http://localhost:3001';
export const QUANTA_API_BASE_URL = 'https://points.ducatprotocol.com/';

export const quantaApi = axios.create({
  baseURL: QUANTA_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// optional request logger
quantaApi.interceptors.request.use(
  (config) => {
    console.log(`[Quanta API] ${config.method?.toUpperCase()} ${config.url}`, config);

    return config;
  },
  (error) => {
    console.error('[Quanta API] Request error:', error);

    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  }
);

// optional response logger
quantaApi.interceptors.response.use(
  (response) => {
    console.log(`[Quanta API] Response from ${response.config.url}:`, response.data);

    return response;
  },
  (error) => {
    console.error('[Quanta API] Response error:', error);

    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  }
);
